import type { SelectOptionCtx } from '@cli-types/next-adapter/generators.js'
import { renderGenGetSelectOptionsContentServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-get-select-options-content.js'
import { buildSelectOptionFieldNames } from './build-select-option-field-names.js'

export function genGetSelectOptionsContent(ctx: SelectOptionCtx): string {
  return renderGenGetSelectOptionsContentServerActionTemplate({
    ctxSelectOptionsTableVar: ctx.selectOptionsTableVar,
    ctxCacheReadImport: ctx.cacheReadImport,
    ctxCamelSingular: ctx.camelSingular,
    ctxSingular: ctx.Singular,
    selectOptionFieldNames: buildSelectOptionFieldNames(ctx),
    ctxCacheLifeLine: ctx.cacheLifeLine,
    ctxSingularText: ctx.singular
  })
}
